/**
 * Machine-readable error codes for the attachments API (ADR-0010 §2, §7).
 * Error bodies carrying these codes are generic: they never echo the file
 * name, the declared MIME type or any byte content.
 */ /** HTTP 415: sniffed kind is not allowed, disagrees with the declared type, or a PDF has active content. */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ATTACHMENT_EMPTY () {
        return ATTACHMENT_EMPTY;
    },
    get ATTACHMENT_INFECTED () {
        return ATTACHMENT_INFECTED;
    },
    get ATTACHMENT_TOO_LARGE () {
        return ATTACHMENT_TOO_LARGE;
    },
    get ATTACHMENT_TYPE_NOT_ALLOWED () {
        return ATTACHMENT_TYPE_NOT_ALLOWED;
    }
});
const ATTACHMENT_TYPE_NOT_ALLOWED = 'ATTACHMENT_TYPE_NOT_ALLOWED';
const ATTACHMENT_TOO_LARGE = 'ATTACHMENT_TOO_LARGE';
const ATTACHMENT_EMPTY = 'ATTACHMENT_EMPTY';
const ATTACHMENT_INFECTED = 'ATTACHMENT_INFECTED';
